import { ReactElement, RefObject, forwardRef } from 'react'
import { ListBoxBaseProps } from './Types'
import { VirtualizedListBoxBase } from './VirtualizedListBoxBase/VirtualizedListBoxBase'
import { NonVirtualizedListBoxBase } from './NonVirtualizedListBoxBase/NonVirtualizedListBoxBase'
import { isTest } from 'utils/nodeEnv'

function ListBoxBase<T extends object>(props: ListBoxBaseProps<T>, ref: RefObject<HTMLDivElement>) {
  if (props.isVirtualized && !isTest()) {
    return <VirtualizedListBoxBase {...props} ref={ref} />
  }

  const { isVirtualized, layout, ...rest } = props

  return <NonVirtualizedListBoxBase {...rest} ref={ref} />
}

// @ts-expect-error
const _ListBoxBase = forwardRef(ListBoxBase) as <T extends object>(
  props: ListBoxBaseProps<T> & { ref?: RefObject<HTMLDivElement> },
) => ReactElement
export { _ListBoxBase as ListBoxBase }
